<div class="item-container">
  <div class="item-header">
    <h5 class="text-center"> Job usage</h5>
    <div class="edit-icons" mat-dialog-close>
      <i class="material-icons">close</i>
    </div>
  </div>
  <div class="item-content ">
    <div class="table-container table-container-n">
      <div class="d-flex justify-content-between align-items-center user-container">
        <div class="user-profile name mt-3">
          <div class="profile-img me-2" [appBackgroundImg]="dialogData.profile_picture"> </div>
          <div class="">
            <div class="main-head">{{dialogData.first_name}} {{dialogData.last_name}}</div>
            <div class="sub-head">{{dialogData.email}}</div>
          </div>
        </div>
        <button (click)="onExportCSV()"
          class="btn c-btn mt-3 btn-outline-grey outline-btn no-sh-btn d-flex align-items-center justify-content-center"
          type="submit"> <img src="assets/images/icons/export_csv.svg" class="img-fluid me-1">Export CSV</button>
      </div>
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 demo-table">
        <ng-container matColumnDef="shift-date">
          <th mat-header-cell *matHeaderCellDef> Shift date </th>
          <td mat-cell *matCellDef="let element"> {{element.date | dates }} </td>
        </ng-container>
        <ng-container matColumnDef="clock-in">
          <th mat-header-cell *matHeaderCellDef> Clock in </th>
          <td mat-cell *matCellDef="let element">
            <div class="d-flex gap-2">
              <input class="form-control" type="text" [(ngModel)]="element.st_ti">
              <button class="btn btn-primary" (click)="onChangeTime(element)">Save</button>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="clock-out">
          <th mat-header-cell *matHeaderCellDef class="group-col">Clock out </th>
          <td mat-cell *matCellDef="let element" class="group-col">
            <div class="d-flex gap-2">
              <input class="form-control" type="text" [(ngModel)]="element.ed_ti">
              <button class="btn btn-primary" (click)="onChangeTime(element)">Save</button>
            </div>
          </td>

        </ng-container>
        <ng-container matColumnDef="total-hours">
          <th mat-header-cell *matHeaderCellDef> Total hours</th>
          <td mat-cell *matCellDef="let element"> {{element.wo_ti}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
</div>
<app-loading-spinner></app-loading-spinner>